import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'
import App from './App';
import { BrowserRouter } from "react-router-dom";

import { PrismicProvider } from '@prismicio/react'
import { client } from './Prismic'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PrismicProvider client={client}>
  <React.StrictMode>
    <BrowserRouter>
    <App />
    </BrowserRouter>
  </React.StrictMode>
  </PrismicProvider>
);



